import React, { Fragment } from 'react';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import ServiceProviderDetails from '../../Component/SiteOwnerPanel/serviceProvider';

const ServiceProvider = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="Service Providers" title="Service Providers" />
      <ServiceProviderDetails />
    </Fragment>
  );
};
export default ServiceProvider;